export default "__VITE_ASSET__G4i29JeI__"